/**
 * Default collection privacy used when explicit collection/profile privacy cannot be resolved.
 */
export const COLLECTION_IS_PRIVATE_DEFAULT = true;
